import PropTypes from "prop-types";
import React, { useState } from "react";
import Heading from "../../elements/heading";
import TableSelect from "../../elements/table-select";
import BodyText from "../../elements/body-text";

import "./style.scss";

const Summary = props => {
  const { details, text, images, callback, selectedColor, showCarSelection } = props;
  const { membership, deposit, price } = details;
  const selection = details.selection || {};
  const { color, engine } = selection.choices || {};
  const [carColor, setCarColor] = useState(selectedColor);

  const handleCallback = (key, selectedOption) => {
    try {
      selection.choices[key].selected = selectedOption;
      callback({
        color: color.selected,
        engine: engine.selected
      });
    } catch (error) {
      console.error("error calling summary callback", error);
    }
  };
  return (
    <section className="summary">
      {images?.length > 0 && (
        <div className="summary-header">
          <img src={images[0].path} alt={images[0]?.alt} className="car-image" />
        </div>
      )}

      <div className="summary-inner">
        <Heading {...text.heading} />
        <BodyText html={text.body} className="body-text" />
        <div className="details">
          <Heading {...membership.heading} />
          <div className="table-select table-select-borderd">
            <div className="label">{membership.country.label}:</div>
            <div className="label white">{membership.country.value}</div>
          </div>
          <div className="table-select table-select-borderd">
            <div className="label">{membership.membership.label}:</div>
            <div className="label white">{membership.membership.value}</div>
          </div>

          {selection && showCarSelection && (
            <>
              <Heading {...selection.heading} />
              {engine && <TableSelect className="table-select-borderd" {...engine} onSelect={option => handleCallback("engine", option)} />}
              {color && (
                <TableSelect
                  {...color}
                  className="table-select-borderd"
                  onSelect={option => {
                    setCarColor(option.value);
                    handleCallback("color", option);
                  }}
                />
              )}
            </>
          )}
          {deposit && (
            <>
              <Heading {...deposit.heading} />
              <div className="table-select table-select-borderd">
                <div className="label">{price.label}:</div>
                <div className="label white">
                  {/*{price.value + deposit.currency}*/}
                  {price.value}
                </div>
              </div>
              <div className="table-select table-select-borderd">
                <div className="label">{deposit.deposit.label}:</div>
                <div className="label white">
                  {/*{deposit.deposit.value + deposit.currency}*/}
                  {deposit.deposit.value}
                </div>
              </div>
              <BodyText html={deposit.disclaimer.body} className="body-text" />
            </>
          )}
        </div>
      </div>
    </section>
  );
};

Summary.propTypes = {
  details: PropTypes.shape({
    membership: PropTypes.shape({
      heading: PropTypes.object,
      country: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      }),
      membership: PropTypes.shape({
        label: PropTypes.string,
        value: PropTypes.string
      })
    }),
    selection: PropTypes.shape({
      heading: PropTypes.object,
      choices: PropTypes.shape({
        color: PropTypes.object,
        engine: PropTypes.object
      })
    }),
    deposit: PropTypes.shape({
      heading: PropTypes.object,
      deposit: PropTypes.shape({
        value: PropTypes.string,
        info: PropTypes.string
      }),
      disclaimer: PropTypes.object
    })
  }),
  text: PropTypes.object,
  // images: PropTypes.shape({
  //   black: PropTypes.array,
  //   blue: PropTypes.array
  // }),
  callback: PropTypes.func,
  showCarSelection: PropTypes.bool,
  selectedColor: PropTypes.string
};

export default Summary;
